<template>
	<div class="inner-page design-meeting">

		<div v-if="thisCase.status != 'archive'">

			<Placeholder
				v-if="actualProgressStage == 5"
				message="You can no longer view this stage."
				:withBackButton="true"
				/>

			<template v-else>

				<AppHead title="Design Meeting" />

				<div v-if="thisCase.progress_stage < 3 || $page.props.user.user_type == 'admin'">

					<PageHeader 
						title="Design Meeting"
						desc="Attend your design meeting to discuss your case."
						:hasButton="false"
						:showHelper="false"
						/>

					<CaseProgressBar 
						:step="thisCase.progress_stage" 
						:thisCase="thisCase"
						:pageStep="2"
						/>

					<div
						v-if="thisCase.design_meeting_details != null" 
						class="show-meeting-details"
						>

						<Subtitle
							title="Design Meeting Details"
							/>

						<div class="white-box" v-html="linkify(thisCase.design_meeting_details)" />

					</div>

					<Placeholder
						v-else
						message="Please check back soon to find out your design meeting details."
						:withBackButton="true"
						/>

				</div>
				<Placeholder
					v-else
					message="You have already completed this step. Please go back to the case overview to find what your next step is."
					:withBackButton="true"
					/>

			</template>

		</div>
		<Placeholder
			v-else
			message="This case has been archived. You can no longer edit it."
			:withBackButton="true"
			/>

		

	</div>
</template>

<script>

import AppLayout from "@/Layouts/AppLayout.vue"
import AppHead from "@/Components/AppHead"
import PageHeader from "@/Components/PageHeader"
import Button from "@/Components/Button"
import CaseProgressBar from "@/Components/Cases/CaseProgressBar"
import Subtitle from "@/Components/Subtitle"
import Placeholder from "@/Components/Placeholder"

import moment from 'moment'

export default {
	props: [
		'thisCase'
	],
	components: {
		AppLayout,
		AppHead,
		PageHeader,
		Button,
		CaseProgressBar,
		Subtitle,
		Placeholder
	},
	layout: AppLayout,
	data: () => {
		return {
			isFormComplete: false,
		}
	},
	methods: {
		linkify(inputText) {
			let replacedText, replacePattern1, replacePattern2, replacePattern3;

			//URLs starting with http://, https://, or ftp://
			replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
			replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

			//URLs starting with "www." (without // before it, or it'd re-link the ones done above).
			replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
			replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

			//Change email addresses to mailto:: links.
			replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
			replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

			return replacedText;
		}
	},
	computed: {
		actualProgressStage(){
			if(this.thisCase.override_progress !== null){
				return this.thisCase.override_progress
			}else{
				return this.thisCase.progress_stage
			}
		}
	}
};

</script>

<style scoped lang="sass">

.design-meeting

	.white-box
		background-color: #fff
		padding: 20px
		margin-bottom: 30px
		border-radius: 8px
		box-shadow: 0 0 10px rgba(0,0,0,0.1)

					

	.button-box
		display: flex

</style>